import { buildModelManager } from "../builder.js";
const DefaultQaRoutingRoleSelection = {
  __typename: true,
  id: true,
  active: true,
  createdAt: true,
  description: true,
  displayLabel: true,
  domainPolicies: true,
  institution: true,
  key: true,
  name: true,
  permissions: true,
  seeded: true,
  stableKey: true,
  updatedAt: true,
  workflowId: true
};
const modelApiIdentifier = "qaRoutingRole";
const pluralModelApiIdentifier = "qaRoutingRoles";
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultQaRoutingRoleSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultQaRoutingRoleSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultQaRoutingRoleSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultQaRoutingRoleSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultQaRoutingRoleSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultQaRoutingRoleSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultQaRoutingRoleSelection,
    namespace: null
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "qaRoutingRoleGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const QaRoutingRoleManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultQaRoutingRoleSelection,
  operations
);
export {
  DefaultQaRoutingRoleSelection,
  QaRoutingRoleManager
};
//# sourceMappingURL=QaRoutingRole.js.map
